(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("glamorous"), require("glamor/react"), require("styled-system"), require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define("glam-react-styles", ["glamorous", "glamor/react", "styled-system", "react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["glam-react-styles"] = factory(require("glamorous"), require("glamor/react"), require("styled-system"), require("react"), require("prop-types"));
	else
		root["glam-react-styles"] = factory(root["glamorous"], root["glamor/react"], root["styled-system"], root["React"], root["Prop-types"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition